import { Call } from '@domains';
import { createAction, props } from '@ngrx/store';

export enum CallActionType {
  GetCalls = '[Captain] Get Calls',
  GetCallsSuccess = '[Captain] Get Calls Success',
}

export const getCalls = createAction(CallActionType.GetCalls, props<{ leadId: string }>());
export const getCallsSuccess = createAction(CallActionType.GetCallsSuccess, props<{ resultsCount: number; results: Array<Call> }>());
